import _ from 'lodash';
import Backbone from 'backbone';

import Scaffold from '@/Scaffold';
import ErrorView from '@/views/ErrorView/ErrorView';
import { userHasRole } from '@/util/RoleUtils';

import ReportsView from '../views/ReportsView/ReportsView';
import GetAllReports from '../services/GetAllReports';

export default async function loadReportsView() {
  if (!userHasRole('Admin')) {
    showAuthError({ message: 'Unauthorized' });
    return;
  }

  try {
    const reports = await GetAllReports();

    return new ReportsView({
      model: new Backbone.Model({
        reports
      })
    });
  } catch (err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the Reports page.'
        })
      })
    );
  }
}

function showAuthError(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'Access Denied',
        errorDetails: 'Your account may not have permission to view the Reports page.'
      })
    })
  );
}
